/*
 *
 * WorldRecords constants
 *
 */

import {WorldRank} from "./worldrecords";

export const SLICE_NAME = 'worldrecords';

export const WorldRankValue = {
    [WorldRank.Recreation]: 'Recreation',
    [WorldRank.Junior]: 'Junior',
    [WorldRank.Regional]: 'Regional',
    [WorldRank.National]: 'National',
    [WorldRank.International]: 'International',
};
